<template>
  <div class="motivate">
    <div class="motivate_form">
      <el-form
        :inline="true"
        :model="motivateForm"
        ref="motivateFormRefs"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="motivateForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="motivate_table">
      <div class="table_add">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-show="
            authorization('/home-admin/routineManage/incentive-manage/add')
          "
          @click="edit(false)"
        >
          新增
        </el-button>
      </div>
      <el-table
        :data="tableData"
        stripe
        height="80%"
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        v-loading="loading"
      >
        <el-table-column
          prop="name"
          label="名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="激励类型">
          <template slot-scope="scope">
            <span v-if="scope.row.incentiveType === 1">正</span>
            <span v-else>负</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="attachmentIds" label="附件">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.attachmentIds && scope.row.attachmentIds.length > 0
              "
            >
              <el-button
                type="text"
                size="small"
                @click="seeFileList(scope.row.attachmentIds.split(','))"
                >{{ scope.row.attachmentIds.split(",").length }}</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="createdByStr" label="创建人"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column prop="updatedByStr" label="修改人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-end"
              v-show="
                authorization('/home-admin/routineManage/fee-group-manage/edit')
              "
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                style="margin-right: 5px; margin-left: 5px"
                @click="edit(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top-end"
              v-show="
                authorization('/home-admin/routineManage/fee-group-manage/del')
              "
            >
              <el-popconfirm
                title="确认删除吗？"
                @confirm="deleteData(scope.row)"
              >
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          padding-top: 20px;
          height: 40px;
          background-color: #fff;
          width: 100%;
          border-radius: 0 0 8px 8px;
          text-align: right;
        "
      >
        <el-pagination
          background
          :page-sizes="sizes"
          layout="total,sizes,prev,pager,next"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormEdit"
      width="700px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form
        :model="motivateDialogForm"
        :rules="motivateDialogRules"
        ref="userArray"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="名称:" prop="name">
          <el-input
            v-model="motivateDialogForm.name"
            maxlength="100"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="激励类型:" prop="incentiveType">
          <el-select
            v-model="motivateDialogForm.incentiveType"
            placeholder="请选择激励类型"
            style="width: 100%"
          >
            <el-option label="正" value="1"></el-option>
            <el-option label="负" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            maxlength="500"
            v-model="motivateDialogForm.remarks"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件:">
          <UpLoad
            :fileSize="100"
            ref="uploadRefs"
            :limit="100"
            @remove="removeFile"
            @uploadSuccess="handleUploadSuccess"
          ></UpLoad>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="motivateSubmit"
          size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
  </div>
</template>

<script>
import UpLoad from "@/components/UpLoad";
import { authorization } from "../../../authorization/authorization";
import FileList from "@/components/FileList";
export default {
  name: "Motivate",
  components: {
    UpLoad,
    FileList,
  },
  data() {
    return {
      motivateForm: {
        name: "",
      },
      motivateDialogForm: {
        name: "",
        incentiveType: "1",
        remarks: "",
        attachmentIds: [],
      },
      motivateDialogRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        incentiveType: [
          { required: true, message: "请选择激励类型", trigger: "blur" },
        ],
      },
      tableData: [{ account: "123" }],
      total: 0,
      sizes: [10, 15, 20, 50],
      dialogFormEdit: false,
      title: "新增",
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      currentData: {},
      loading: false,
    };
  },
  created() {
    this.getData(false);
  },
  methods: {
    handleUploadSuccess(res) {
      this.motivateDialogForm.attachmentIds.push(res);
    },
    seeFileList(ids) {
      this.$refs.fileListRefs.open(ids);
    },
    removeFile(file, fileList) {
      this.motivateDialogForm.attachmentIds = fileList.map((item) => item.uid);
    },
    authorization,
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData(true);
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.getData(true);
    },
    getData(flag) {
      if (!flag) {
        this.page.pageNum = 1;
        this.page.pageSize = 10;
      }
      const data = {
        page: this.page.pageNum,
        size: this.page.pageSize,
        queryInfoParams: {
          name: this.motivateForm.name,
        },
      };
      this.loading = true;
      this.axios({
        url: "/v1/web/routine-manage/incentive-manage/list",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(data) {
      if (data) {
        this.motivateDialogForm = {
          name: data.name,
          incentiveType: data.incentiveType + "",
          remarks: data.remarks,
          attachmentIds: data.attachmentIds
            ? data.attachmentIds.split(",")
            : [],
        };
        if (this.motivateDialogForm.attachmentIds.length > 0) {
          this.getFileList(this.motivateDialogForm.attachmentIds);
        }
        this.currentData = data;
        this.title = "编辑";
      } else {
        this.title = "新增";
      }
      this.dialogFormEdit = true;
    },
    getFileList(val) {
      this.axios({
        url: "/attachment/list",
        method: "POST",
        data: {
          ids: val.join(","),
        },
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.fileList = res.data.data.map((item) => {
            return {
              name: item.fileName,
              url: item.fileUrl,
              uid: item.id,
            };
          });
          this.$refs.uploadRefs.fileList = this.fileList;
        }
      });
    },
    motivateSubmit() {
      if (this.title === "新增") {
        this.add();
      } else {
        this.editData();
      }
    },
    add() {
      if (this.motivateDialogForm.attachmentIds.length > 0) {
        this.motivateDialogForm.attachmentIds =
          this.motivateDialogForm.attachmentIds.join(",");
      } else {
        this.motivateDialogForm.attachmentIds = "";
      }
      this.axios({
        url: "/v1/web/routine-manage/incentive-manage/add",
        method: "post",
        data: this.motivateDialogForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("新增成功");
          this.getData(true);
          this.closeDialog();
          this.dialogFormEdit = false;
        } else {
          this.$message.error(res.data.message);
          // this.dialogFormEdit = false
        }
      });
    },
    editData() {
      if (this.motivateDialogForm.attachmentIds.length > 0) {
        this.motivateDialogForm.attachmentIds =
          this.motivateDialogForm.attachmentIds.join(",");
      } else {
        this.motivateDialogForm.attachmentIds = "";
      }
      this.axios({
        url: `/v1/web/routine-manage/incentive-manage/edit/${this.currentData.id}`,
        method: "post",
        data: {
          id: this.currentData.id,
          name: this.motivateDialogForm.name,
          incentiveType: this.motivateDialogForm.incentiveType - 0,
          remarks: this.motivateDialogForm.remarks,
          attachmentIds: this.motivateDialogForm.attachmentIds,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("编辑成功");
          this.getData(true);
          this.closeDialog();
          this.dialogFormEdit = false;
        } else {
          this.$message.error(res.data.message);
          // this.dialogFormEdit = false
        }
      });
    },
    closeDialog() {
      this.$refs.userArray.resetFields();
      this.motivateDialogForm = {
        name: "",
        incentiveType: "1",
        remarks: "",
        attachmentIds: [],
      };
      this.dialogFormEdit = false;
      this.$refs.uploadRefs.fileList = [];
    },
    reset() {
      this.$refs.motivateFormRefs.resetFields();
    },
    deleteData(data) {
      this.axios({
        url: `/v1/web/routine-manage/incentive-manage/del/${data.id}`,
        method: "DELETE",
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.getData(true);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.motivate {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.motivate_form {
  width: 100%;
  overflow: hidden;
}

.motivate_table {
  height: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 0 20px;
}

.table_add {
  margin-bottom: 10px;
}
</style>
